import { NgModule } from '@angular/core';
import { PrimengModule } from './primeng/primeng.module';
import { RequiredDirective } from './directives/required.directive';
import { TranslateModule } from '@ngx-translate/core';
import { ParkingModule } from './parking/parking.module';
import { AllowanceModule } from './allowance/allowance.module';
import { LoadingModule } from './mobility/loading/loading.module';
import { WelcomeUserModule } from './mobility/welcome-user/welcome-user.module';
import { COMMON_MODULES } from './constants/common-modules';
import { TooltipModule } from './mobility/tooltip/tooltip.module';
import { UserHasRoleDirective } from './directives/user-has-role.directive';
import { MobNumberPipe } from './pipes/mob-number.pipe';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';

@NgModule({
  declarations: [RequiredDirective, UserHasRoleDirective, MobNumberPipe, ConfirmDialogComponent],
  imports: [
    ...COMMON_MODULES,
    ParkingModule,
    AllowanceModule,
    LoadingModule,
    WelcomeUserModule,
    TooltipModule,
  ],
  exports: [
    RequiredDirective,
    UserHasRoleDirective,
    MobNumberPipe,
    PrimengModule,
    TranslateModule,
    ParkingModule,
    AllowanceModule,
    LoadingModule,
    WelcomeUserModule,
    TooltipModule,
  ],
})
export class SharedModule {}
